// Generate four random hex digits.
const S4 = () => {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};

export const oneOf = (value, validList) => {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true;
    }
  }
  return false;
};

// Generate a pseudo-GUID by concatenating random hexadecimal
export const newGuid = () => {
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
};

export const getQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
};

export const rdmWord = () => {
  Math.random().toString(36).substr(2);
};

export default {
  oneOf,
  newGuid,
  getQueryString,
  rdmWord
};



// WEBPACK FOOTER //
// ./src/utils/helper.js